var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import reportDefault from "@/components/Workflow/Editor/reportDefault";
import { useWorkflowCommentStore } from "@/stores/workflowEditorCommentStore";
import { useWorkflowStateStore } from "@/stores/workflowEditorStateStore";
import { useWorkflowEditorToolbarStore } from "@/stores/workflowEditorToolbarStore";
import { useWorkflowStepStore } from "@/stores/workflowStepStore";
/**
 * Loads a workflow into the editor
 *
 * @param id ID of workflow to load data *into*
 * @param data Workflow data to load from
 * @param appendData if true appends data to current workflow, making sure to create new uuids
 * @param defaultPosition where to position workflow in the editor
 */
export function fromSimple(id, data, options) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function* () {
        const appendData = (_a = options === null || options === void 0 ? void 0 : options.appendData) !== null && _a !== void 0 ? _a : false;
        const defaultPosition = (_b = options === null || options === void 0 ? void 0 : options.defaultPosition) !== null && _b !== void 0 ? _b : { top: 0, left: 0 };
        const commentStore = useWorkflowCommentStore(id);
        const stateStore = useWorkflowStateStore(id);
        const stepStore = useWorkflowStepStore(id);
        const toolbarStore = useWorkflowEditorToolbarStore(id);
        // If workflow being copied into another, wipe UUID and let
        // Galaxy assign new ones.
        if ((_c = options === null || options === void 0 ? void 0 : options.reassignIds) !== null && _c !== void 0 ? _c : appendData) {
            const stepIdOffset = stepStore.getStepIndex + 1;
            Object.values(data.steps).forEach((step) => {
                delete step.uuid;
                if (!step.position) {
                    // Should only happen for manually authored editor content,
                    // good enough for a first pass IMO.
                    step.position = { top: step.id * 100, left: step.id * 100 };
                }
                step.id += stepIdOffset;
                step.position.left += defaultPosition.left;
                step.position.top += defaultPosition.top;
                Object.values(step.input_connections).forEach((link) => {
                    if (link === undefined) {
                        console.error("input connections invalid", step.input_connections);
                    }
                    else {
                        let linkArray;
                        if (!Array.isArray(link)) {
                            linkArray = [link];
                        }
                        else {
                            linkArray = link;
                        }
                        linkArray.forEach((link) => {
                            link.id += stepIdOffset;
                        });
                    }
                });
            });
            data.comments.forEach((comment, index) => {
                comment.id = commentStore.highestCommentId + 1 + index;
            });
        }
        Object.values(data.steps).map((step) => {
            var _a;
            stepStore.addStep(step, appendData, (_a = options === null || options === void 0 ? void 0 : options.createConnections) !== null && _a !== void 0 ? _a : true);
        });
        commentStore.addComments(data.comments, [defaultPosition.left, defaultPosition.top], appendData);
        if (!appendData) {
            stateStore.report = (_d = data.report) !== null && _d !== void 0 ? _d : {
                markdown: reportDefault,
            };
        }
        toolbarStore.currentTool = "pointer";
    });
}
export function toSimple(id, workflow) {
    const steps = workflow.steps;
    const report = workflow.report;
    const license = workflow.license;
    const creator = workflow.creator;
    const annotation = workflow.annotation;
    const name = workflow.name;
    const tags = workflow.tags;
    const commentStore = useWorkflowCommentStore(id);
    commentStore.resolveCommentsInFrames();
    commentStore.resolveStepsInFrames();
    const comments = workflow.comments.filter((comment) => !(comment.type === "text" && comment.data.text === ""));
    return { steps, report, license, creator, annotation, name, comments, tags };
}
